import React from "react";
import { func, bool, string, element, oneOfType } from "prop-types";

import { Link } from "react-router-dom";
import { Button } from "../../../../common/index";

import Container from "./Container";
import Header from "./Header";

const LinkButton = ({ to, children }) => (
  <div style={{ marginBottom: 15 }}>
    <Link
      to={to}
      className="btn-plain d-block text-info m-auto text-center"
      style={{ width: 264, marginBottom: 20 }}
    >
      {children}
    </Link>
  </div>
);

LinkButton.propTypes = {
  to: string.isRequired,
  children: oneOfType([element, string]).isRequired,
};

const WorkReferences = ({
  renderForm,
  renderCards,
  isFormVisible,
  showForm,
  description,
  descriptionForm,
  isEditing,
  loading,
}) => (
  <Container>
    <Header description={isFormVisible ? description : descriptionForm} />
    {isFormVisible ? (
      renderForm()
    ) : (
      <div className="row flex-column justify-content-center align-content-center">
        <Button
          classes="btn btn-primary btn-block my-2"
          styles={{ width: 264, margin: "auto" }}
          onClick={showForm}
        >
          Add another
        </Button>
        {!loading && <LinkButton to="/profile">Save</LinkButton>}
      </div>
    )}

    {!isEditing && renderCards()}
  </Container>
);

WorkReferences.propTypes = {
  renderForm: func.isRequired,
  renderCards: func.isRequired,
  isFormVisible: bool.isRequired,
  showForm: func.isRequired,
  description: string.isRequired,
  descriptionForm: string.isRequired,
  isEditing: bool.isRequired,
  loading: bool.isRequired,
};

export default WorkReferences;
